import { services } from '@nvision/identity-core';

export const checkIdentityLogin = () => {
  const isIdentityLogin = !services.auth.isOIDCProviderDisabled();

  return {
    isIdentityLogin,
  };
};
